export default __webpack_public_path__ + "static/media/pin-sam-man-tsai.d3a8a367.png";